import { render, staticRenderFns } from "./PerformanceScoreModal.vue?vue&type=template&id=210393ad&scoped=true"
import script from "./PerformanceScoreModal.vue?vue&type=script&lang=js"
export * from "./PerformanceScoreModal.vue?vue&type=script&lang=js"
import style0 from "./PerformanceScoreModal.vue?vue&type=style&index=0&id=210393ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210393ad",
  null
  
)

export default component.exports